import { Trans } from "react-i18next"

export default function DeadlineApproaching({ ownerIdea }) {
  return (
    <Trans
      i18nKey="notifications.ideaDeadlineApproaching"
      values={{ idea: ownerIdea?.name || "Deleted" }}
      components={{ b: <b /> }}
    />
  )
}
